import styled from 'styled-components';

const Placeholder = styled.div`
  width: 100%;
`;

export {
  Placeholder,
};
